import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ApiSettingsUtils } from "../configuration/configuration.types";

@Injectable({
    providedIn: "root",
})
export abstract class ApiService {
    protected httpClient = inject(HttpClient);

    protected baseUrl!: string;

    constructor(path: string) {
        this.baseUrl = ApiSettingsUtils.getApiUrl(environment.apiSettings, path);
    }
}